import { Modal as ModalComponent } from '@arionbanki/arionui';

type ModalDefinition = React.FC<
	Readonly<{
		className?: string;
		background?: 'dim';
		handleClose: () => void;
		isOpen: boolean;
		width?: string;
		children?: React.ReactNode;
	}>
>;

export const Modal = ModalComponent as unknown as ModalDefinition;
